"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CobrandBatchStatuses = exports.NettwerkBatchStatuses = exports.getSocialsFromArtistGroup = exports.ArtistGroupSocials = exports.ArtistGroupTypeArray = exports.ArtistGroupTypes = exports.ArtistGroupRoles = exports.getReducedName = exports.presave = void 0;
exports.presave = __importStar(require("./presave"));
__exportStar(require("./brandPartnerships"), exports);
var fans_1 = require("./fans");
Object.defineProperty(exports, "getReducedName", { enumerable: true, get: function () { return fans_1.getReducedName; } });
exports.ArtistGroupRoles = ["artist", "admin", "manager"];
exports.ArtistGroupTypes = [
    "music-artist",
    "comedian",
    "brand",
    "non-music-other",
];
exports.ArtistGroupTypeArray = exports.ArtistGroupTypes.map((type) => ({
    label: type
        .replace(/-/g, " ") // Replace hyphens with spaces
        .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize each word
        .replace(/\bOther$/i, "(Other)"), // Wrap the word 'Other' with parentheses
    value: type,
}));
exports.ArtistGroupSocials = ["facebook", "twitter", "instagram", "youtube", "tiktok"];
const getSocialsFromArtistGroup = (group) => {
    const socials = {};
    for (const key of exports.ArtistGroupSocials) {
        if (group[key]) {
            socials[key] = group[key];
        }
    }
    return socials;
};
exports.getSocialsFromArtistGroup = getSocialsFromArtistGroup;
const BackfillStatuses = ["in_progress", "complete", "error"];
exports.NettwerkBatchStatuses = ["uploaded", "error"];
exports.CobrandBatchStatuses = ["pending", "complete", "error"];
//# sourceMappingURL=index.js.map